import { createHashHistory, createBrowserHistory } from 'history'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../c... Remove this comment to see the full error message

import { OUTLOOK365 } from '../constants/LoginSources';
/**
 * Certain hosting environments, like O365 WebViews,
 * require hash routing as browserHistory is not supported.
 * @param {string} source
 */

const requiresHashRouting = source => source === OUTLOOK365;

export default (({
  rootUrl,
  source
}) => {
  return (requiresHashRouting(source) ? createHashHistory : createBrowserHistory)({
    basename: rootUrl
  });
});